import { apiConnector } from "../apiconnector";
import toast from "react-hot-toast";
import { nodeEndpoints } from "../apis";

// Create a node
export const createNode = async (data, token) => {
  try {
    const response = await apiConnector(
      "POST",
      nodeEndpoints.CREATE_NODE_API,
      data,
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Node created successfully");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to create node");
    throw err;
  }
};

// Get all nodes by Drawing Sheet ID
export const getNodesByDrawingSheet = async (drawingSheetId, token) => {
  try {
    const response = await apiConnector(
      "GET",
      nodeEndpoints.GET_NODES_BY_DRAWINGSHEET_API(drawingSheetId),
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch nodes");
    throw err;
  }
};

// Get single node by Node ID
export const getSingleNode = async (nodeId, token) => {
  try {
    const response = await apiConnector(
      "GET",
      nodeEndpoints.GET_SINGLE_NODE_API(nodeId),
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch node details");
    throw err;
  }
};

// Delete node by ID
export const deleteNode = async (nodeId, token) => {
  try {
    const response = await apiConnector(
      "DELETE",
      nodeEndpoints.DELETE_NODE_API(nodeId),
      null,
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Node deleted successfully");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to delete node");
    throw err;
  }
};

// Mark node as completed by employee
export const markNodeComplete = async (nodeId, token) => {
  try {
    const response = await apiConnector(
      "PATCH",
      nodeEndpoints.MARK_NODE_COMPLETE_API(nodeId),
      null,
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Node marked as completed");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to mark node as complete");
    throw err;
  }
};

// Get node by node number (optional lookup)
export const getNodeByNumber = async (nodeNumber, token) => {
  try {
    const response = await apiConnector(
      "GET",
      nodeEndpoints.GET_NODE_BY_NUMBER_API(nodeNumber),
      null,
      { Authorization: `Bearer ${token}` }
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch node by number");
    throw err;
  }
};







// import axios from "axios";
// import { nodeEndpoints } from "../apis";

// // Create a node
// export const createNode = async (data, token) => {
//   try {
//     const response = await axios.post(nodeEndpoints.CREATE_NODES_API, data, {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error creating node:", error);
//     throw error;
//   }
// };

// // Get all nodes for logged-in user
// export const getNodes = async (token) => {
//   try {
//     const response = await axios.get(nodeEndpoints.GET_NODES_API, {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching nodes:", error);
//     throw error;
//   }
// };

// // Delete node by ID
// export const deleteNode = async (id, token) => {
//   try {
//     const response = await axios.delete(nodeEndpoints.DELETE_NODE_API(id), {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error deleting node:", error);
//     throw error;
//   }
// };

// // Get node by nodeNumber
// export const getNodeByNumber = async (nodeNumber, token) => {
//   try {
//     const response = await axios.get(nodeEndpoints.GET_NODE_BY_NUMBER_API(nodeNumber), {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching node by number:", error);
//     throw error;
//   }
// };

// // (Optional) Get node by MongoDB ID — if needed in frontend
// export const getNodeById = async (id, token) => {
//   try {
//     const response = await axios.get(nodeEndpoints.GET_NODE_BY_ID_API(id), {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching node by ID:", error);
//     throw error;
//   }
// };
